module.exports = __webpack_public_path__ + "img/dsci0127.d81e052e.jpg";